import {ref, watch} from 'vue'
import {themeStorage} from '@/helpers/storage'

export enum Theme {
  Light = 'light',
  Dark = 'dark',
}

const theme = ref<Theme>((themeStorage.get() as Theme) || Theme.Light)

function applyTheme(value: Theme) {
  if (value === Theme.Dark) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
}

applyTheme(theme.value)

watch(theme, (value) => {
  themeStorage.set(value)
  applyTheme(value)
})

export function useTheme() {
  const isDark = ref(theme.value === Theme.Dark)

  watch(isDark, (value) => {
    theme.value = value ? Theme.Dark : Theme.Light
  })

  watch(theme, (value) => {
    isDark.value = value === Theme.Dark
  })

  function toggleTheme() {
    isDark.value = !isDark.value
  }

  return {
    theme,
    isDark,
    toggleTheme,
  }
}
